import React from 'react';
import { Text as Txt } from 'react-native';

const Text = props => <Txt style={[{
}, props.style]}>{props.children}</Txt>;

export default Text;
